import {  VideoCameraIcon } from '@heroicons/react/24/outline'
import { useActiveSession } from "@/store/sessionStore"

export function Calisma(){

    const { isActive, isPaused, duration, isCameraActive } = useActiveSession()

  const displayTime = () => {
    const hours = Math.floor(duration / 3600)
    const minutes = Math.floor((duration % 3600) / 60)
    const secs = duration % 60

    if (hours > 0) {
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    }

    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
  }

  return <>{isActive && (
            <div className="flex items-center gap-2 text-sm text-gray-600">
              {isCameraActive && (
                <div className="flex items-center gap-1 text-green-600">
                  <VideoCameraIcon className="w-4 h-4" />
                  <span className="hidden sm:inline">Kamera</span>
                </div>
              )}
              <span className="hidden sm:inline">Çalışma: {displayTime()}</span>
              {isPaused && <span className="text-orange-600">(Duraklatıldı)</span>}
            </div>
          )}</>
}